module.exports = __webpack_public_path__ + "img/icon_map_3_on_100.cc36502f.png";